<block-ui></block-ui>
  <div class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column">

        </div>
        <div class="card-toolbar">
          <div class="subheadertoolbar">
            <a class="btn btn-light-primary btn-sm" (click)="changeCurrentLanguage('ar')" *ngIf="Lang=='en'">
              {{utilityService.getResourceValue("Arabic")}}

            </a>
            <a class="btn btn-light-primary btn-sm" (click)="changeCurrentLanguage('en')" *ngIf="Lang=='ar'">
              {{utilityService.getResourceValue("English")}}
            </a>
          </div>
        </div>
      </div>
      <div class="card-body">
        <form [formGroup]="EditEmailForm" *ngIf="IsAEditFormLoaded" (ngSubmit)="editEmailTemplate()">
          <div class="kt-form">
            <div *ngIf="Lang=='ar'">
              <div class="row">
                <div class="form-group col-md-6">
                  <BBSF-TextBox [options]="EmailSubjectInArabic" [group]="EditEmailForm">
                  </BBSF-TextBox>
                </div>
                <div class="form-group col-md-12">
                  <BBSF-HtmlEditor [options]="EmailBodyInArabic" [group]="EditEmailForm">
                  </BBSF-HtmlEditor>
                </div>
                <div class="form-group col-md-6">
                  <BBSF-TextBox [options]="HtmlBodyTagAttributesArabic" [group]="EditEmailForm">
                  </BBSF-TextBox>
                </div>

                <div class="form-group col-md-6">
                  <BBSF-TextBox [options]="HTMLHeadSectionInArabic" [group]="EditEmailForm">
                  </BBSF-TextBox>
                </div>
              </div>
            </div>

            <div *ngIf="Lang=='en'">
              <div class="row">
                <div class="form-group col-md-6">
                  <BBSF-TextBox [options]="EmailSubjectInEnglish" [group]="EditEmailForm">
                  </BBSF-TextBox>
                </div>


                <div class="form-group col-md-12">
                  <BBSF-HtmlEditor [options]="EmailBodyInEnglish" [group]="EditEmailForm">
                  </BBSF-HtmlEditor>
                </div>
                <div class="form-group col-md-6">
                  <BBSF-TextBox [options]="HtmlBodyTagAttributesEnglish" [group]="EditEmailForm">
                  </BBSF-TextBox>
                </div>

                <div class="form-group col-md-6">
                  <BBSF-TextBox [options]="HTMLHeadSectionInEnglish" [group]="EditEmailForm">
                  </BBSF-TextBox>
                </div>
              </div>
            </div>

          </div>
          <div class=" kt-form__actions col-12 d-flex justify-content-end">
            <button type="submit" class="btn btn-primary btn-sm ">{{utilityService.getResourceValue("SaveLabel")}}</button>
          </div>
        </form>
      </div>
    </div>


  </div>
  

